// The money in the navbar's panels (NavAccount's and NavBilling's), hidden
// behind an eye as Tencent Cloud's is: one switch for every figure in both,
// remembered per browser.
import { ref } from 'vue'
import { money } from '@/utils/format'

const KEY = 'cdnx_hide_balance'

function remembered() {
  try {
    return localStorage.getItem(KEY) === '1'
  } catch {
    return false // private mode: shown
  }
}

export const balanceHidden = ref(remembered())

export function toggleBalanceHidden() {
  balanceHidden.value = !balanceHidden.value
  try {
    localStorage.setItem(KEY, balanceHidden.value ? '1' : '0')
  } catch {
    /* not remembered */
  }
}

/** A sum in 分 as the panels show it: **** while hidden, — until read. */
export function shown(cents: number | undefined) {
  if (cents === undefined) return '—'
  return balanceHidden.value ? '****' : money(cents)
}

/** The first of this month on the customer's own clock; 本月消费 counts from it. */
export function monthStart() {
  const d = new Date()
  return new Date(d.getFullYear(), d.getMonth(), 1).toISOString()
}
